module.exports = __webpack_public_path__ + "static/media/WEX.15eef0d7.png";